import {Injectable} from '@angular/core';
import {environment} from '../environments/environment';

export class ConfigModel {
    urlServicios: string = "";
    secret: string = "";
}

@Injectable()
export class Config {
    private cadenas: ConfigModel;

    public Configuracion: ConfigModel;

    constructor() {
        this.cadenas =
        {
            urlServicios: environment.url,
            secret: 'SDBtMzFuNzNyMW9SMi5zMHMxLjFuQzNQdDFvLkg0c1ByMzJ1UHUzc1QwMg==',
        };

        this.Configuracion = this.cadenas;
    }
}
